import React from 'react';
import PropTypes from 'prop-types';

const ModalTitle = ({ onHide, children }) => {
	return (
		<div className='n-modal-header'>
			<h5 className='n-modal-title'>{children}</h5>
			{onHide && (
				<button className='n-btn n-btn-xs' onClick={onHide}>
					&times;
				</button>
			)}
		</div>
	);
};

ModalTitle.propTypes = {
	children: PropTypes.string,
};

export default ModalTitle;
